import type { LoadingState } from "../../domain/data-layer/loading-state";
import { useFetched } from "./use-fetched";

export function useFetchedConstant<T>(eff: () => Promise<T>): LoadingState<T> {
  return useFetched(eff, { dataKey: "constant" });
}
